export const GatewayOp = {
    DISPATCH: 0,
    HEARTBEAT: 1,
    IDENTIFY: 2,
    PRESENCE_UPDATE: 3,
    RESUME: 6,
    RECONNECT: 7,
    INVALID_SESSION: 9,
    HELLO: 10,
    HEARTBEAT_ACK: 11,
    /** Client → server: the app went to (or came back from) the background. */
    APP_STATE: 12,
};
export const GatewayCloseCode = {
    UNKNOWN_ERROR: 4000,
    UNKNOWN_OPCODE: 4001,
    DECODE_ERROR: 4002,
    NOT_AUTHENTICATED: 4003,
    AUTHENTICATION_FAILED: 4004,
    ALREADY_AUTHENTICATED: 4005,
    INVALID_SEQ: 4007,
    RATE_LIMITED: 4008,
    SESSION_TIMED_OUT: 4009,
};
//# sourceMappingURL=gateway.js.map